import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Box } from '@mui/material';

/**
 * Warning badge shown on the right of a coverage chip when some matches are off tolerance.
 */
export function ScheduleStatusOffToleranceIndicator() {
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'warning.main',
        color: 'warning.contrastText',
        borderRadius: '50%',
        p: 0.25,
        ml: 0.5,
      }}
    >
      <WarningAmberIcon fontSize="inherit" />
    </Box>
  );
}
